import { Autocomplete, TextField } from "@mui/material";
import { memo, useEffect, useState } from "react";
import CentroVirtual from "../classes/KeyValue";
import PropriedadeParceiroDataSet from "../data/PropriedadeParceiroDataSet";
import { useTranslation } from "react-i18next";

function AutocompleteCentroVirtual(props: AutocompleteCentroVirtualProps) {
    const { t } = useTranslation();
    const dataSet = new PropriedadeParceiroDataSet();
    const [data, setData] = useState<CentroVirtual[]>([]);
    const [dataFilter, setDataFilter] = useState<CentroVirtual[]>([]);

    useEffect(() => {
        const codigoFornecedorSap = Number(localStorage.getItem("CodigoFornecedorSAPSelecionado"));
        dataSet.ListarCentrosVirtuais(codigoFornecedorSap).then(
            (result) => setData(result)
        );
    }, [])

    /* useEffect(() => {
         dataSet.ListarAtivos().then((result) => setData(result));
     }, [])*/

    useEffect(() => {
        if (dataFilter !== null && dataFilter !== undefined && dataFilter.length === 1)
            localStorage.setItem("centroVirualSel", String(dataFilter[0].value));
        else
            if (dataFilter.length !== 1)
                localStorage.removeItem("centroVirualSel");
    }, [dataFilter])

    const handlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDataFilter(data.filter(f => f.value.toString().startsWith(event.target.value)))
    }

    return (
        <>
            <Autocomplete
                size='small'
                freeSolo
                id="free-solo-2-demo"
                disableClearable
                options={data.map((option: any) => option.value)} // + ' - ' + option.key
                onChange={(e) => {
                    setDataFilter(data.filter(f => (f.value) === String(e.currentTarget.textContent))); //+ ' - ' + f.key
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={t("common.autoComplete.centroVirtual.label")}
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                        }}
                        onChange={handlerOnChange}
                    />
                )}
            />
        </>
    )
}

interface AutocompleteCentroVirtualProps {

}

export default memo(AutocompleteCentroVirtual);
